import { render, staticRenderFns } from "./DebugPermissions.vue?vue&type=template&id=d2ffe242&scoped=true&"
import script from "./DebugPermissions.vue?vue&type=script&lang=js&"
export * from "./DebugPermissions.vue?vue&type=script&lang=js&"
import style0 from "./DebugPermissions.vue?vue&type=style&index=0&id=d2ffe242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ffe242",
  null
  
)

export default component.exports